var exports = {
  "j": "ComponentGalleryTabButtonsTab.module__buttonsWrapper___NXgtWW",
};

module.exports = exports;
